import { View, TextInput, StyleSheet, ImageBackground, Pressable, FlatList } from 'react-native'
import React, { useEffect, useState, createContext, useContext } from "react";
import { Route, NavLink, Link, Routes, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-data-grid/lib/styles.css';
import './App.css';
import { ThemeContext } from './context/ThemeContext';
// require('dotenv').config();
//import { BrowserRouter as Router, Route } from 'react-router-dom';

//import { PrivateRoute } from './_components';
// import { HomePage } from './HomePage';
// import { LoginPage } from './LoginPage';
// import Home from './Home';
// import About from './About';
import Master from './Master/Master';
import Appt from './Appt/Appt';
import Talker from './Talker/Talker';
import Sayers from './Sayers/Sayers';
import Users from './Users/User';
import Farms from './Farms/Farms';
import Scheds from './Sched/Scheds';
import Where from './Where/Where';
import Home from './Home';
// import LoginPanel from './Login';
// import WipPanel from './Wip';

function App() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  const { colorScheme, setColorScheme, theme } = useContext(ThemeContext);
  // console.log('App ThemeContext', ThemeContext);
  // console.log('App theme', theme);
  // console.log('App colorScheme', colorScheme);
  const styles = createStyles(theme, colorScheme);
  const [ok2Go, setOk] = useState(false);
  const [dayUser, setDay] = useState('');
  const [data, setData] = useState(null);


  var AuthUser = {
    id: '',
    name: '',
    permissions: [],
    roles: []
  };

  var ProtectedRouteProps = {
    isAllowed: false,
    redirectPath: '',
    children: React.ReactNode
  };

  // const ProtectedRoute = ({ isAllowed, redirectPath = "/", children }) => {
  //   if (!isAllowed) {
  //     return <Navigate to={redirectPath} replace />;
  //   }
  //   return children ? children : <Outlet />;
  // };
/*
        <Route
          path="ml"
          element={
            <ProtectedRoute
              redirectPath="/home"
              isAllowed={true}
            >
              if (!isAllowed) {<Navigate to={redirectPath} replace />}

              <Master />
            </ProtectedRoute>
          }
        />

*/



  // const [allowed, setAllowed] = useState(false);
  const loginHandler = (login) => {
    if (login) {
      var cherryUser = dayUser;
      fetch(`${apptsUrl}jokeEven?day=${cherryUser}`)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          // data.map((rec, index) => (
          //   document.title = `${rec.atWhen.split('-')[0]}|${rec.apptClient}`
          // ))
        })
        .catch(error => console.error(error));
      setOk(true);
    } else {
      setOk(false);
    }
  }

  const location = useLocation();

  useEffect(() => {
    fetch(`${apiUrl}getservers`)
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error(error));
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/sched' element={<Scheds />} />
        <Route path='/farm' element={<Farms />} />
        <Route path='/where' element={<Where />} />
        <Route path='/master' element={<Master />} />
        <Route path='/talker' element={<Talker />} />
        <Route path='/talker/:tkr' element={<Talker />} />
        <Route path="/sayers/" element={<Sayers />} />
        <Route path="/users/" element={<Users />} />
        <Route path="/work/:id" element={<Appt />} />
        <Route path="/admin/:id" element={<Appt />} />
      </Routes>
      <main className="App-main">
        {(!(location.pathname.startsWith('/work') || location.pathname.startsWith('/admin'))) ?
          <Navbar fixed="top" bg="dark" data-bs-theme="dark" expand="lg" className="bg-body-tertiary">
            <Navbar.Brand href="/">&nbsp;Cherry2024</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="container-fullwidth">
                <NavLink style={{ paddingRight: "10px" }} to="/home">Home</NavLink>
                <a rel={'external'}
                  target="_blank" href={"http://dash.cherry2024.com:2082/d/adrc3y6qrqbk0e/cherry2024-live-farms?orgId=1&refresh=1m"}>Live</a>
                {ok2Go
                  ?
                  <Container>
                    <NavLink style={{ paddingRight: "5px" }} to="/sched">Calendar</NavLink>
                    <NavLink style={{ paddingRight: "5px" }} to="/farm">Farms</NavLink>
                  </Container>
                  : <span>&nbsp;</span>
                }
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          :
          <span>&nbsp;</span>
        }
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              {data ?
                <div className="container-fluid">
                  <div className="row  ">
                    <div className="col-sm-12">
                      {!ok2Go
                        ?
                        <div className="container">
                          <h2>Login To Cherry2024</h2>
                          <div>
                            <label>User Name ({React.version})</label>
                            <TextInput
                              style={styles.user}
                              onChangeText={setDay}
                              value={dayUser}
                              keyboardType="default"
                            />

                          </div>
                          <div className="form-group">
                            <button className="btn btn-primary" onClick={() => loginHandler(true)}>Login</button>
                          </div>
                        </div>
                        : <></>

                      }
                    </div>
                  </div>
                </div>
                : <h4 className="stattext">&nbsp;&nbsp;Loading ...</h4>}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;

function createStyles(theme, colorScheme) {
  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      backgroundColor: 'black',
      // backgroundColor: theme.background,
    },
    text: {
      // color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      // backgroundColor: '#202',
      flex: 2,
    },
    textthin: {
      //      color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      // backgroundColor: '#202',
      flex: 1,
    },
    text1: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      // backgroundColor: '#202',
      flex: 2,
    },
    text1thin: {
      // color: theme.text,
      color: 'white',
      fontSize: '1.2em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      // backgroundColor: '#202',
      flex: 1,
    },
    rush: {
      color: 'red',
      fontSize: '1.1em',
      textAlign: 'center',
      // backgroundColor: theme.background,
      backgroundColor: 'white',
    },
    title: {
      // color: theme.header,
      color: 'orange',
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.background,
      backgroundColor: 'black',
      width: "90%"
    },
    link: {
      // color: theme.text,
      color: 'white',
      fontSize: 42,
      fontWeight: 'bold',
      textAlign: 'center',
      backgroundColor: 'rgba(16,0,16,0.7)',
      textDecorationLine: 'underline',
    },
    button: {
      height: 40,
      borderRadius: 5,
      padding: 6,
      // backgroundColor: theme.button,
      backgroundColor: 'royalblue',
      justifyContent: 'center',
    },
    butttonText: {
      // color: theme.text,
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 4,
    },
    icon: {
      // color: theme.text,
      color: 'white',
      fontSize: 36,
      // backgroundColor: theme.background,
      backgroundColor: 'black',
      textAlign: 'right',
      verticalAlign: 'middle',
      padding: 1,
      width: '10%'
    },
    user: {
      color: 'white',
      fontSize: '2em',
      fontWeight: 'bold',
      textAlign: 'left',
      width: '100%',
    },
    viewrow: {
      flexDirection: 'row',
      width: '100%',
    },
    row: {
      height: '100',
      width: '100%',
      flexDirection: 'row',
      marginBottom: 2,
    },
    rowodd: {
      backgroundColor: 'black',
    },
    roweven: {
      backgroundColor: 'rgba(16,0,16,0.7)',
    },
    sep: {
      height: 3,
      backgroundColor: 'gray',
      width: '50%',
      maxWidth: 400,
      marginHorizontal: 'auto',
      marginBottom: 2,
    },
    image: {
      height: '100%',
      width: 'auto',
      flex: 1,
      justifyContent: 'center',
    }
  })
}

